/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Share_Notes_BodyInputs */



/**
* | output |
* | --- |
* | "Paste your notes and Wundo writes the report." |
*
* @param {Meeting_Report_Share_Notes_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_share_notes_body = /** @type {((inputs?: Meeting_Report_Share_Notes_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Share_Notes_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Plak je notities en Wundo stelt het verslag op.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collez vos notes et Wundo rédige le compte rendu.")
	return /** @type {LocalizedString} */ ("Paste your notes and Wundo writes the report.")
});